
import { defineComponent } from 'vue'
import { Menu } from '@web/store/types/modules/menu'
import Analytics from '@web/services/Analytics/Analytics'
import { useRouter } from 'vue-router'
import AsExternalDocument from '@web/components/AsExternalDocument.vue'

export default defineComponent({
  model: {
    prop: 'mini',
    event: 'minify'
  },
  components: {
    AsExternalDocument
  },
  props: {
    menu: {
      type: Object as () => Menu,
      default: () => ({} as Menu)
    },
    status: {
      type: String,
      default: '-open'
    },
    minify: {
      type: Boolean,
      default: false
    },
    mini: {
      type: Boolean,
      default: false
    },
    type: {
      type: String as () => 'menu' | 'sidebar',
      default: 'menu'
    }
  },
  emits: ['minify', 'click:item'],
  setup (props, ctx) {
    const router = useRouter()

    function handlerMinify () {
      ctx.emit('minify', !props.mini)
    }

    function goTo (i, item) {
      ctx.emit('click:item', item)
      if (i === 'support') {
        Analytics.send({
          category: 'support_activity',
          action: 'open_support',
          label: props.type
        })
      }

      router.push(item.link)
    }

    return {
      handlerMinify,
      goTo
    }
  }
})
